

    export interface IResponse { 
        successful: boolean;
        message: string;
    }

    export class Response implements IResponse {
        successful: boolean;
        message: string;
    }
 